import _ from 'lodash'
import * as actionTypes from '../actions/actions'

const initialState = {
    apiHeaders: {},
    orgNames: '',
    eligibleOrgIds: '',
    orgAiCodes: '',
    currentRequest: {},
    requestCount: 0,
    isLoading: true,
    unauthorized: false
}

const reducer = (state = initialState, action) => {
    switch (action.type)
    {
        case actionTypes.REQUEST_ORGS:
            if (!_.isEmpty(action.data) && !action.data.Status)
            {
                return {
                    ...state,
                    apiHeaders: action.data.apiHeaders,
                    orgNames: action.data.orgData.map(org => org.orgName),
                    eligibleOrgIds: action.data.orgData.map(org => org.orgId.toString()),
                    orgAiCodes: action.data.orgData.map(org => org.aiCode),
                    currentRequest: action.data.request,
                    requestCount: action.data.requestCount ? action.data.requestCount : 0,
                    isLoading: false,
                }
            }
            else
            {
                return {
                    ...state,
                    unauthorized: true
                }
            }
        case actionTypes.API_CALL_ERROR:
            return {
                ...state,
                ...action.data
            }
        default:
            return state
    }
}

export default reducer
